import { render, staticRenderFns } from "./SignatureDetailView.vue?vue&type=template&id=0872e1ce&scoped=true"
import script from "./SignatureDetailView.vue?vue&type=script&lang=js"
export * from "./SignatureDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872e1ce",
  null
  
)

export default component.exports